var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08912 0C1.8117 0 0.766541 1.08 0.766541 2.4V21.6C0.766541 22.92 1.8117 24 3.08912 24H17.0246C18.302 24 19.3472 22.92 19.3472 21.6V7.2L12.3794 0H3.08912ZM3.08912 2.4H11.2182V8.4H17.0246V21.6H3.08912V2.4ZM5.4117 12V14.4H14.702V12H5.4117ZM5.4117 16.8V19.2H11.2182V16.8H5.4117Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b50cf3c25907602c2a9b114327354eaf.svg";
export { ForwardRef as ReactComponent };